/** LKR SSCL-inclusive breakdown (2026-11-04) — the payment form's live
 * preview of what the server saves (backend feeMath.ts splitInclusiveSscl):
 * the figure entered is the total paid INCLUDING SSCL; amount excluding SSCL
 * = total × divisor, rounded half-up to the cent; SSCL = total − that.
 * Worked in whole cents (and the divisor in ten-thousandths, as stored), so
 * no floating-point rounding can make it disagree with the server.
 * Example (divisor 0.975): 10,000.00 → 9,750.00 + 250.00. */
export const ssclBreakdown = (totalInclSscl: number, divisor: number) => {
  const totalCents = Math.round(totalInclSscl * 100);
  const divisorTenThousandths = Math.round(divisor * 10000);
  const exclCents = Math.floor((totalCents * divisorTenThousandths + 5000) / 10000);
  return {
    totalInclSscl: totalCents / 100,
    amountExclSscl: exclCents / 100,
    ssclAmount: (totalCents - exclCents) / 100,
  };
};

/** SSCL is split out of the entered total only for a taxable category paid in LKR. */
export const isSsclInclusive = (
  currencyCode: string | null | undefined,
  isTaxable: boolean | undefined,
) => !!isTaxable && currencyCode?.toUpperCase() === 'LKR';
